/* OneFit 4.7 Ultra lander (sections/onefit-47-ultra.liquid).

   A copy of assets/onelife-usa-teaser.js, kept to what this page has: the
   soft parallax, the comparison pills, the effects tabs, the rails and the
   expert videos that play in place. Gone with the parts they drove: the
   teaser's footer subscribe (the page wears the site footer), the
   ingredient clip (a still pouch here) and the customer Mux clips.

   Every lookup is inside .of47u: the page also carries the V88 buy box,
   the ritual panel and the site chrome, which must not be picked up by
   selectors as broad as [data-rail] or [data-fx]. */
(function(){
  var Q = function(sel){ return [].slice.call(document.querySelectorAll('.of47u ' + sel)); };

  /* ---------- Soft parallax ----------
     Photographs inside a fixed frame only, where a few pixels of
     counter-movement reads as depth. */
  (function(){
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (reduce) return;
    var targets = Q('[data-parallax]');
    if (!targets.length) return;
    var ticking = false;
    function frame(){
      ticking = false;
      var vh = window.innerHeight;
      targets.forEach(function(el){
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var p = ((r.top + r.height / 2) - vh / 2) / (vh / 2);
        var amt = parseFloat(el.dataset.parallax) || 14;
        el.style.setProperty('--py', (p * amt).toFixed(2) + 'px');
      });
    }
    function onScroll(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(frame);
    }
    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', onScroll);
    frame();
  })();

  /* ---------- Comparison, phone: which competitor is shown ----------
     data-vs is the column (3, 4 or 5) the phone shows beside OneFit; the
     CSS hides the other two. Desktop ignores it. */
  Q('.cmp--four').forEach(function(sec){
    var pills = [].slice.call(sec.querySelectorAll('[data-vs-pick]'));
    pills.forEach(function(p){
      p.addEventListener('click', function(){
        sec.setAttribute('data-vs', p.getAttribute('data-vs-pick'));
        pills.forEach(function(q){ q.setAttribute('aria-pressed', q === p ? 'true' : 'false'); });
      });
    });
  });

  /* ---------- Effects: time tabs ---------- */
  (function(){
    var tabs = Q('[data-fx]');
    if (!tabs.length) return;
    var panels = Q('.fx__panel');
    function show(key){
      tabs.forEach(function(t){
        var on = t.dataset.fx === key;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function(p){
        var on = p.id === 'fx-' + key;
        p.classList.toggle('is-on', on);
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
    }
    tabs.forEach(function(t, i){
      t.addEventListener('click', function(){ show(t.dataset.fx); });
      t.addEventListener('keydown', function(e){
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var next = tabs[(i + d + tabs.length) % tabs.length];
        next.focus();
        show(next.dataset.fx);
      });
    });
  })();

  /* ---------- Rails: arrows scroll by one card ----------
     Once per [data-rail], so the ingredients and the experts each get
     their own arrows. A rail that fits retires its arrows. */
  Q('[data-rail]').forEach(function(wrap){
    var rail = wrap.querySelector('[data-rail-track]');
    if (!rail) return;
    var prev = wrap.querySelector('[data-rail-prev]');
    var next = wrap.querySelector('[data-rail-next]');
    var nav  = wrap.querySelector('[data-rail-nav]');
    function step(){
      var card = rail.querySelector('[data-rail-slide]');
      if (!card) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function sync(){
      var max = rail.scrollWidth - rail.clientWidth - 1;
      if (prev) prev.disabled = rail.scrollLeft <= 0;
      if (next) next.disabled = rail.scrollLeft >= max;
      if (nav) nav.classList.toggle('is-idle', max <= 0);
    }
    if (prev) prev.addEventListener('click', function(){ rail.scrollBy({left: -step(), behavior: 'smooth'}); });
    if (next) next.addEventListener('click', function(){ rail.scrollBy({left:  step(), behavior: 'smooth'}); });
    rail.addEventListener('scroll', sync, {passive: true});
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---------- Expert videos that play in place ----------
     Press a still and its video is created there and then, so nothing is
     fetched for a card nobody presses; one playing pauses any other. */
  (function(){
    var playing = null;
    function claim(el){
      if (playing && playing !== el && typeof playing.pause === 'function') playing.pause();
      playing = el;
    }
    Q('[data-olus-video]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (btn.querySelector('video')) return;
        var v = document.createElement('video');
        v.src = btn.getAttribute('data-olus-video');
        v.controls = true; v.playsInline = true; v.preload = 'metadata';
        v.setAttribute('playsinline', '');
        claim(v);
        btn.classList.add('is-playing');
        btn.appendChild(v);
        v.play().catch(function(){});
        v.addEventListener('play', function(){ claim(v); });
      });
    });
  })();
})();
